import {gql} from "@apollo/client";

const LISTINGS_BY_IDS = gql`
    query L ($ids: [ID], $tags: [ID]){
        listingsById (ids: $ids, tags: $tags) {
            Identifier
            Title
            Type
            URLSegment
            ThirdpartyURL
            AbsoluteLink
            Website
            Featured
            CustomTileDescription
            CustomLinkListingDirectlyToExternalLink
            FullAddressHTML
            Summary
            MainImage {
                Title
                AbsoluteURL
                Loading
                Sized(width: 320, height: 240)
            }
            MainCategory {
                ID
                Identifier
            }
            Categories {
                edges {
                    node {
                        ID
                        Identifier
                    }
                }
            }
        }
    }
`

export default LISTINGS_BY_IDS;

